import styles from './DateIcon.module.css';

const DateInIcon = ({ date, month }: { date: string; month: string }) => {
    return (
        <div className={styles.container} data-testid="date-in-icon">
            <div className={styles.month}>{month}</div>
            <div className={styles.date}>{date}</div>
        </div>
    );
};

// eslint-disable-next-line import/no-default-export
export default DateInIcon;
